var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarPanels2Directions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "290px",
    height: "201px",
    viewBox: "0 0 290 201",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Loop-Optimise",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LO-connect---solar-help-modals",
    transform: "translate(-723, -282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(723.0725, 282.9275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43-Copy",
    transform: "translate(144.9275, 100) rotate(-90) translate(-144.9275, -100)translate(44.9275, -44.9275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#584380",
    x: 0,
    y: 0,
    width: 200,
    height: 120.772947
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-21",
    fill: "#0C1F28",
    points: "80.1932367 120.772947 200 -2.93310733e-15 200 289.855072 80.1932367 289.855072"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-22",
    fill: "#D7CEE0",
    points: "-7.97134768e-13 60.3864734 0 120.772947 80.1932367 120.772947 140.096618 60.3864734"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-23",
    fill: "#B09FCA",
    points: "80.1932367 289.855072 80.1932367 120.772947 140.096618 60.3864734 140.096618 289.855072"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-43",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(89.9275, 182.6449) scale(-1, 1) rotate(-270) translate(-89.9275, -182.6449)",
    x: 80.4275362,
    y: 168.644928,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-44",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(89.9275, 163.6449) scale(-1, 1) rotate(-270) translate(-89.9275, -163.6449)",
    x: 80.4275362,
    y: 149.644928,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-45",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(89.9275, 144.6449) scale(-1, 1) rotate(-270) translate(-89.9275, -144.6449)",
    x: 80.4275362,
    y: 130.644928,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-46",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(89.9275, 125.6449) scale(-1, 1) rotate(-270) translate(-89.9275, -125.6449)",
    x: 80.4275362,
    y: 111.644928,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-47",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(134.9275, 87.6449) scale(-1, 1) rotate(-360) translate(-134.9275, -87.6449)",
    x: 125.427536,
    y: 73.6449278,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-48",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(153.9275, 87.6449) scale(-1, 1) rotate(-360) translate(-153.9275, -87.6449)",
    x: 144.427536,
    y: 73.6449278,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-49",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(172.9275, 87.6449) scale(-1, 1) rotate(-360) translate(-172.9275, -87.6449)",
    x: 163.427536,
    y: 73.6449278,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-50",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(191.9275, 87.6449) scale(-1, 1) rotate(-360) translate(-191.9275, -87.6449)",
    x: 182.427536,
    y: 73.6449278,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-51",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(210.9275, 87.6449) scale(-1, 1) rotate(-360) translate(-210.9275, -87.6449)",
    x: 201.427536,
    y: 73.6449278,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-52",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(229.9275, 87.6449) scale(-1, 1) rotate(-360) translate(-229.9275, -87.6449)",
    x: 220.427536,
    y: 73.6449278,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-53",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(248.9275, 87.6449) scale(-1, 1) rotate(-360) translate(-248.9275, -87.6449)",
    x: 239.427536,
    y: 73.6449278,
    width: 19,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-54",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#0C1F28",
    transform: "translate(267.9275, 87.6449) scale(-1, 1) rotate(-360) translate(-267.9275, -87.6449)",
    x: 258.427536,
    y: 73.6449278,
    width: 19,
    height: 28
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPanels2Directions);
export default __webpack_public_path__ + "static/media/solar-panels-2-directions.2f7c44d064f4af25c16693af614a10fa.svg";
export { ForwardRef as ReactComponent };